import clsx from "clsx";

import { Tab, Tabs, Trigger } from "@/components/molecules/Tabs/Tabs";

import {
  Card as ArticleCard,
  isArticleCard
} from "@/bloks/ArticleCard/ArticleCard";
import fetchArticleListing from "@/bloks/ArticleListingBlok/fetchArticleListing";
import ProductCard from "@/components/molecules/ProductCard";
import { isProductCard } from "@/components/molecules/ProductCard/ProductCard";
import { fetchTabs } from "@/lib/storyblok/storyblokServerFunctions";
import CSSSlider from "./CSSSlider";
import styles from "./tabs-ui.module.css";

const TabsUI = ({
  title,
  tabsData,
  cardType = "product",
  preview
}: {
  title?: string;
  tabsData?:
    | Awaited<ReturnType<typeof fetchArticleListing>>
    | Awaited<ReturnType<typeof fetchTabs>>;
  cardType?: "article" | "product";
  preview: boolean;
}) => {
  const tabs = tabsData;
  const isSingleTab = tabsData?.length === 1;

  if (tabs?.every((tab) => !tab.cards.length)) return null; // all empty

  return (
    <div className={styles.root} data-layout="blok" data-mobile-bleed="true">
      {title && (
        <h2
          className={clsx(
            "blok-title",
            styles.title__spacing,
            isSingleTab && styles.single__tab
          )}
        >
          {title}
        </h2>
      )}
      {tabs && (
        <Tabs tabIds={tabs?.map((tab) => tab._uid)}>
          {!isSingleTab && (
            <div className={styles.tags}>
              {tabs?.map((tab, i) => (
                <Trigger tabId={tab._uid} key={tab._uid + "trigger" + i}>
                  <button className="transparent" type="button">
                    {tab.name}
                  </button>
                </Trigger>
              ))}
            </div>
          )}
          {tabs?.map((tab, i) => (
            <Tab tabId={tab._uid} key={tab._uid + "tab" + i}>
              <CSSSlider uuid={tab._uid}>
                {tab?.cards?.map((card, i) => (
                  <div
                    className={clsx(
                      styles.slide,
                      cardType === "article" && styles.article__slide
                    )}
                    key={"card-" + tab._uid + "-" + i}
                  >
                    {cardType === "product" && isProductCard(card) ? (
                      <ProductCard productCard={card} />
                    ) : (
                      isArticleCard(card) && (
                        <ArticleCard article={card} slideshow />
                      )
                    )}
                  </div>
                ))}
              </CSSSlider>
            </Tab>
          ))}
        </Tabs>
      )}
    </div>
  );
};

export default TabsUI;
